import React from "react";

export default function NumberDisplay({
  fontawesomeIcon = null,
  number = null,
  title = null,
}) {
  return (
    <div className="h-[105px] w-[197px] border border-altgray-200 rounded-md mt-2.5 flex flex-col m-2 md:w-[197px] md:m-2 md:mb-4">
      <div className="bg-altgray-50 font-semibold pt-2 pb-1.5 text-[90%] border-b border-altgray-200 rounded-t-md flex items-center justify-center w-full">
        <div className="mr-2.5 text-orange-400">{fontawesomeIcon}</div> {title}
      </div>
      <div className="flex flex-row flex-1 justify-center items-center">
        <div className="flex items-center justify-center text-[150%] font-bold md:text-[200%]">
          {number}
        </div>
      </div>
    </div>
  );
}


